export default "__VITE_ASSET__b5e02935__"